import React from 'react';
import { connect } from 'react-redux';
import MintingRow from '../AnalyticsPage/MintingRow';

const mapStateToProps = (state) => {
  let myAccount = state.account.currentAccount;

  if (typeof myAccount === 'string') {
    myAccount = myAccount.toLowerCase();
  }

  return {
    coinsMinted: state.coinsMinted,
    myAccount: myAccount
  };
};

const connectedMyCoinsMinted = ({coinsMinted, myAccount}) => (
  <div className="c-component c-coins-minted">
    <h2>My Coin Mints</h2>
    <ul className="c-coins-minted__list">
      {coinsMinted
        .filter((a) => a.args.to === myAccount)
        .reverse()
        .slice(0, 10)
        .map((coinsMintedEvent) => (
          <li key={coinsMintedEvent.transactionHash} className="c-coins-minted__list-item">
            <MintingRow coinsMinted={coinsMintedEvent}/>
          </li>
        ))}
    </ul>
  </div>
);

const MyCoinsMinted = connect(mapStateToProps)(connectedMyCoinsMinted);

export default MyCoinsMinted;



// WEBPACK FOOTER //
// ./src/components/HomePage/MyCoinsMinted.js